class GameRules extends SlotGame.src.store.GameRules {


    public rtp: number;

    setData(data: any) {
        super.setData(data);

        const defaultValueRTP = 96;

        this.rtp = data.rtp || defaultValueRTP;
    }
}

export {GameRules};

SlotGame.src.store.GameRules = GameRules;